var map = {
	"./decidim/avatar-multiuser.png": 39275,
	"./decidim/brands/facebook.svg": 72483,
	"./decidim/brands/google.svg": 24986,
	"./decidim/brands/twitter-x.svg": 42059,
	"./decidim/cc-badge.png": 47897,
	"./decidim/decidim-logo.svg": 55705,
	"./decidim/default-avatar.svg": 76681,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 26447,
	"./decidim/icons.svg": 61384,
	"./decidim/pattern.png": 72155,
	"./decidim/placeholder-card-g.svg": 744,
	"./decidim/placeholder-card-l.svg": 23875,
	"./decidim/placeholder.jpg": 72522,
	"./decidim/remixicon.symbol.svg": 12400,
	"./decidim/vendor/social-share-button/douban.svg": 34307,
	"./decidim/vendor/social-share-button/email.svg": 25308,
	"./decidim/vendor/social-share-button/facebook.svg": 99304,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 62156,
	"./decidim/vendor/social-share-button/hacker_news.svg": 11824,
	"./decidim/vendor/social-share-button/linkedin.svg": 27226,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 14883,
	"./decidim/vendor/social-share-button/pinterest.svg": 79338,
	"./decidim/vendor/social-share-button/reddit.svg": 41664,
	"./decidim/vendor/social-share-button/telegram.svg": 6565,
	"./decidim/vendor/social-share-button/tumblr.svg": 79778,
	"./decidim/vendor/social-share-button/twitter.svg": 97689,
	"./decidim/vendor/social-share-button/vkontakte.svg": 76211,
	"./decidim/vendor/social-share-button/wechat.svg": 94302,
	"./decidim/vendor/social-share-button/whatsapp.svg": 48406,
	"./decidim/vendor/social-share-button/x.svg": 41556,
	"./decidim/vendor/social-share-button/xing.svg": 70852
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66546;